import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { errorHandler, successHandler } from '../../../utils';
import {
  CompanyBuilder,
  ActivatePositionInput,
  ActivatePositionOutput,
} from '../companies.types';

export const deactivatePosition = (builder: CompanyBuilder) =>
  builder.mutation<ActivatePositionOutput, ActivatePositionInput>({
    query: (option) => ({
      url: `/positions/deactivate/${option.positionId}`,
      method: 'PATCH',
    }),
    transformResponse: (queryResponse: ActivatePositionOutput, _, arg) => {
      successHandler(
        arg.lang === 'es'
          ? SuccessMessageEs.DeactivatePosition
          : SuccessMessageEn.DeactivatePosition,
        true
      );
      return queryResponse;
    },
    transformErrorResponse: (error, _, arg) => {
      errorHandler(
        '[DeactivatePosition]',
        arg.lang === 'es'
          ? ErrorMessageEs.DeactivatePosition
          : ErrorMessageEn.DeactivatePosition,
        error,
        true
      );
    },
    invalidatesTags: () => [{ type: 'Company', Id: 'LIST' }],
  });
